module.exports = __webpack_public_path__ + "img/spain-square.bcfcec64.png";